import React from "react";
import useStyles from "./styles";

const WhyChooseUs = () => {
  const classes = useStyles();

  const features = [
    {
      id: 1,
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
          <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: "Pan-India Delivery",
      description: "We deliver fresh namkeen to every corner of India with our extensive logistics network"
    },
    {
      id: 2,
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
          <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: "Authentic Taste",
      description: "Traditional recipes passed down through generations, ensuring authentic flavors in every bite"
    },
    {
      id: 3,
      icon: (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
          <path d="M12 2V6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 18V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M4.93 4.93L7.76 7.76" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16.24 16.24L19.07 19.07" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M2 12H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M18 12H22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M4.93 19.07L7.76 16.24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16.24 7.76L19.07 4.93" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: "Freshly Packed",
      description: "Every product is freshly prepared and packed to maintain maximum freshness and quality"
    },
    // {
    //   id: 4,
    //   icon: (
    //     <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
    //       <path d="M12 22S2 16 2 10V5L12 2L22 5V10C22 16 12 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    //       <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    //     </svg>
    //   ),
    //   title: "Secure Payments",
    //   description: "Your transactions are protected with industry-standard encryption and secure payment gateways"
    // }
  ];

  return (
    <div className={classes.whyChooseSec}>
      <div className='container'>
        <div className={classes.sectionHeader}>
          <h2 className={classes.heading}>Why Choose Avon Namkeen?</h2>
          <p className={classes.subheading}>
            We're committed to delivering the finest Indian snacks with unmatched quality and service
          </p>
        </div>

        <div className={classes.featuresGrid}>
          {features.map((feature) => (
            <div key={feature.id} className={classes.featureCard}>
              <div className={classes.featureIcon}>
                {feature.icon}
              </div>
              <h3 className={classes.featureTitle}>{feature.title}</h3>
              <p className={classes.featureDescription}>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
